export enum SessionType {
  P2P = 'p2p',
  Routed = 'routed',
}

// How often we want to receive volume updates. Note: Before changing this ensure all providers support the interval
export const AUDIO_VOLUME_INDICATION_INTERVAL = 100;
// The increment levels to store e.g. 16 gets rounded 20
export const AUDIO_INCREMENTS = 10;

export enum SessionConnectionStatus {
  Disconnected = 'disconnected',
  Connected = 'connected',
  Reconnecting = 'reconnecting',
}

export enum ParticipantVideoDisableReason {
  /**
   * Participant disabled video on their side.
   */
  NotPublished = 'NotPublished',
  /**
   * Vendor drops the participant video stream when connectivity degrades. (Still continues to receive the audio)
   */
  PoorQuality = 'PoorQuality',
  /**
   * Video of the participant is disabled by our application logic for performance optimizations.
   * For example when video of the participants is not needed for the current call layout.
   */
  Unsubscribed = 'Unsubscribed',
  /**
   * Depending on vendor could be some other reasons so we would need to handle it separately or in a general way.
   */
  Other = 'Other',
}

export enum SignalingEventType {
  TransmitUsername = 'transmitUsername',
  TransmitNetworkQuality = 'transmitNetworkQuality',
  /**
   * Will be emitted when the user enable / disable captions.
   */
  ToggleCaptions = 'toggleCaptions',
  /**
   * Captions status that will be send from the server.
   */
  CaptionsStatus = 'captionsStatus',
}
